import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

const ContactSteps = () => {
  return (
    <Grid container spacing={2}>
      <Grid item sm={4} md={12}>
        <Box className="stepsContact" sx={{ position: "relative" }}>
          <Typography variant="h6" className="contactSteps" gutterBottom>
            1. Free technical consultation
          </Typography>
          <Typography
            variant="body1"
            component="p"
            gutterBottom
            sx={{
              lineHeight: 1.55,
              letterSpacing: "-0.14px",
              paddingBottom: { sm: 0, md: "290px" },
              marginBottom: 0,
              fontSize: "16px",
            }}
          >
            Detailed tech plan includes things like what tech stack to use, tech
            architecture, timeline, and budget for your project.
          </Typography>
        </Box>
      </Grid>
      <Grid item sm={4} md={12}>
        <Box className="stepsContact" sx={{ position: "relative" }}>
          <Typography variant="h6" className="contactSteps" gutterBottom>
            2. Connect with the tech team
          </Typography>
          <Typography
            variant="body1"
            component="p"
            gutterBottom
            sx={{
              lineHeight: 1.55,
              letterSpacing: "-0.14px",
              paddingBottom: { sm: 0, md: "290px" },
              marginBottom: 0,
              fontSize: "16px",
            }}
          >
            Over a series of calls, our tech team discusses how different
            technologies and frameworks will bring your vision to life.
          </Typography>
        </Box>
      </Grid>
      <Grid item sm={4} md={12}>
        <Box className="stepsContacts" sx={{ position: "relative" }}>
          <Typography variant="h6" className="contactSteps" gutterBottom>
            3. Onboarding the team
          </Typography>
          <Typography
            variant="body1"
            component="p"
            gutterBottom
            sx={{
              lineHeight: 1.55,
              letterSpacing: "-0.14px",
              paddingBottom: { sm: 0, md: "290px" },
              marginBottom: 0,
              fontSize: "16px",
            }}
          >
            As soon as you sign-off on the team, they’ll be ready to integrate
            into your team—just like in-house employees.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ContactSteps;
